export const EXECUTIVE_SUMMARY_BTN_FILTERS = [
  { id: "dis_btn", name: "DIS", navigateTo: "/executive_summary/dis" },
  { id: "product_btn", name: "Product Performance", navigateTo: "/executive_summary/product_performance" },
  { id: "product_deep_dive_btn", name: "Product Performance - deep dive", navigateTo: "/executive_summary/product_performance_deep_dive" },
];
